import { RuleCounter, RequestPermissions } from '../user-context.model';

export class LoginAppUpdate {
	static readonly type = '[Auth] Login App Update';
	constructor(public appState: any) {}
}

export class LogoutAppUpdate {
	static readonly type = '[Auth] Logout For App Update';
}

export class UserSetActive {
	static readonly type = '[Auth] User Set Active';
}
export class SetUserData {
	static readonly type = '[Auth]  Set User Data';
	constructor(public token: string) {}
}

export class UpdateToken {
	static readonly type = '[Auth] Update Token & User Data';
	constructor(public token: string) {}
}

export class SetIsHasPermissions {
	static readonly type = '[Auth]  Set is an User has permission for some orders';
	constructor(public requestPermissions: RequestPermissions) {}
}

export class UserSetInactive {
	static readonly type = '[Auth] User Set Inactive';
}

export class SetLoginMessage {
	static readonly type = '[Auth] Set Message Login container';
	constructor(public loginMessage: string) {}
}

export class Logout {
	static readonly type = '[Auth] Logout';
	constructor(public force: boolean = true) {}
}

export class UpdateSchemaUrl {
	static readonly type = '[Schema] UpdateSchemaUrl';
	constructor(public payload: { orderId: number; schema: string; revised: boolean, isCMPForm?: boolean }) {}
}

export class AddMenuItem {
	static readonly type = '[Schema] AddMenuItem';
	constructor(public payload: { moduleName: string; item: any }) {}
}

export class RemoveMenuItemByProperty {
	static readonly type = '[Schema] RemoveMenuItemByIndexes';

	constructor(public payload: { property: string, value: string }) {
	}
}

export class UpdateRulesChecked {
	static readonly type = '[Schema] UpdateRulesChecked';
	constructor(public payload: { uiSection: string; ruleCheck: number }) {}
}

export class UpdateOrderRulesChecked {
	static readonly type = '[Schema] UpdateOrderRulesChecked';
	constructor(public payload: Array<RuleCounter>) {}
}

export class SetCloudFrontSignCookies {
	static readonly type = '[Auth]  SetCloudFrontSignCookies';
	constructor(public token: string) {}
}

export class SetIsPublicUser {
	static readonly type = '[Auth] SetIsPublicUser';
	constructor(public isPublicUser: boolean) {}
}
